<template lang="html">
  <md-layout md-align="center" style="text-align:center">
    <div>
      <md-button class="md-icon-button md-accent"  @click="goToPage(1)">
        <md-icon>fast_rewind</md-icon>
        <md-tooltip>primera página</md-tooltip>
      </md-button>
      <md-button :disabled="pagination.current_page === 1" class="md-icon-button md-accent"  @click="goToPage(pagination.current_page - 1)">
        <md-icon>skip_previous</md-icon>
        <md-tooltip>anterior</md-tooltip>
      </md-button>
    </div>
      <div v-if="pagination.current_page > 2" class="paginate" @click="goToPage(pagination.current_page - 2)">{{pagination.current_page - 2}}</div>
      <div v-if="pagination.current_page > 1" class="paginate" @click="goToPage(pagination.current_page - 1)">{{pagination.current_page - 1}}</div>
      <div class="paginate actual" @click="goToPage(pagination.current_page)">{{pagination.current_page}}</div>
      <div v-if="pagination.current_page < pagination.last_page" class="paginate" @click="goToPage(pagination.current_page + 1)">{{pagination.current_page + 1}}</div>
      <div v-if="pagination.current_page < pagination.last_page - 1" class="paginate" @click="goToPage(pagination.current_page + 2)">{{pagination.current_page + 2}}</div>
    <div>
      <md-button :disabled="!pagination.current_page < pagination.last_page" class="md-icon-button md-accent"  @click="goToPage(pagination.current_page + 1)">
        <md-icon>skip_next</md-icon>
        <md-tooltip>siguiente</md-tooltip>
      </md-button>
      <md-button class="md-icon-button md-accent"  @click="goToPage(pagination.last_page)">
        <md-icon>fast_forward</md-icon>
        <md-tooltip>ultima página</md-tooltip>
      </md-button>
    </div>
  </md-layout>
</template>

<script type="text/javascript">
export default {
  props: {
    pagination: {
      type: Object,
      default () {
        return {
          current_page: 1,
          from: 1,
          last_page: 216,
          path: 'http://127.0.0.1:8000/api/v1/articulos',
          per_page: 15,
          to: 15,
          total: 3233
        }
      }
    }
  },
  methods: {
    goToPage (page) {
      this.$emit('PAGINATION_GO_PAGE', page)
    }
  }
}
</script>

<style src="./pagination.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/shared-components/pagination/pagination.vue